import { PrecisionPricingStatusType } from "./booking/types"
import { ReviewsType } from "./favorite/types"

export interface ResponseData {
  apiStatus: ApiStatus
  errorCode?: number | string
  errorMessage?: string
  message?: string
  status?: number
  time: string
}

export enum Status {
  EXPECTATION_FAILED = "EXPECTATION_FAILED",
  INVALID_REQUEST = "INVALID_REQUEST",
  NOT_FOUND = "NOT_FOUND",
  OK = "OK",
  REQUEST_DENIED = "REQUEST_DENIED",
  UNAUTHORIZED = "UNAUTHORIZED",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  ZERO_RESULTS = "ZERO_RESULTS",
}

export enum ApiStatus {
  ACCEPTED = "ACCEPTED",
  ERROR = "ERROR",
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
}

export enum PropertyStatus {
  IN_PROGRESS = "IN_PROGRESS",
  LISTED = "LISTED",
  UNLISTED = "UNLISTED",
}

export type FilterInterfaceForApiRequest = {
  Accessiblity?: string[]
  childAllowed?: boolean
  elevator?: boolean
  eventAllowed?: boolean
  featureByCategory?: {
    "Features & Amenities"?: number[]
    Location?: number[]
    "Property Type"?: number[]
    Safety?: number[]
  }
  features?: string[]
  numberOfBathroom?: number
  numberOfBedroom?: number
  minBed?: number
  numberOfGuest?: number | null
  partyAllowed?: boolean
  petAllowed?: boolean
  prices?: {
    maximum?: number
    minimum?: number
  }
  propertyTypeDesc?: string[]
  ratingEqualAndAbove?: number
  smokeAllowed?: boolean
  suitableChild?: boolean
  suitableInfant?: boolean
}

export interface BoundsType {
  east: number
  north: number
  south: number
  west: number
}

export interface SurveyDto {
  options: {
    surveyOptionFieldType: string
    surveyOptionId: number
    surveyOptionText: string
  }[]
  questionId: number
  questionText: string
  answerType: string
}

// This params defined for store saved search request
export interface PriceRangeType {
  maximum: number
  minimum: number
}

export interface SaveSearchFiltersType {
  featureByCategory?: {
    "Features & Amenities"?: number[]
    Location?: number[]
    "Property Type"?: number[]
    Safety?: number[]
  }
  features?: string[] | null
  numberOfBathroom?: number
  numberOfBedroom?: number
  numberOfGuest?: number
  partyAllowed?: boolean
  petAllowed?: boolean
  prices?: PriceRangeType | null
  propertyTypeDesc: string[] | null
  ratingEqualAndAbove?: number
  smokeAllowed?: boolean
  suitableChild?: boolean
  wheelchairAccessible?: boolean
}

// calendar .ts
export interface OriginalCalendarObject {
  arrival: boolean
  available: boolean
  base_price: number
  departure: boolean
  max_nights: number
  min_nights: number
  valid_from: string
  weekly_arrival?: boolean | null
  whimstay_availability?: boolean
}

export interface FaqData {
  active: boolean
  faqCategory: string
  faqHtmlText: string | null
  faqId: number
  faqOrder: number
  faqSection: string
  faqText: string
  faqType: number
}

interface BoookingAddress {
  address: string
  addressId: number
  city: string
  country: string
  createdAt: number
  emailId: string | null
  firstName: string
  lastName: string
  mobileNumber: string
  nickName: string | null
  pronouns: string | null
  state: string
  userId: number
  zipCode: string
}
interface SplitUserDataV2 {
  addressId: number
  bookingId: number
  bookingNumber: string
  bookingUserId: number
  createdAt: number
  dialerCode: string
  firstName: string
  insuranceAmount: number
  isDeducted: number
  isOwner: number
  mailSent: number
  mobileNumber: string
  promoCode: string | null
  promoCodeAppliedAmount: number
  refundProtect: boolean
  status: string
  transferType: string
  travelerBookingEmail?: string | null
  travelerPaymentAmount: number
  userId: number
}
export interface BookingTrip {
  adultNumber: number
  bookingAddress: BoookingAddress
  bookingAmount: number
  bookingDate: string | null
  bookingDays: string
  bookingNumber: string
  checkInDate: string | null
  checkInTime: string
  checkOutDate: string | null
  cancellationDate: string | null
  childNumber: number | null
  creditAppliedAmount: number
  currency: string
  depositAmount: number
  depositId: string | null
  fullAddress: string
  hostEmail: string
  hostMobile: string
  hostName: string
  isConfirmedByPmc: boolean
  isSplited: number
  itinerary: string
  latitude: number
  longitude: number
  maxNoGuest: number
  optionalFeeAmount: number
  paymentMode?: string
  petNumber: number
  pmcId: string
  pmsType: string
  pmsUnitId: string
  promoCodeAppliedAmount: number
  propertyCity: string
  propertyId: string
  propertyImageLink: string
  propertyName: string
  propertyState: string
  propertyCountry?: string
  propertyTypeDescription?: string
  propertyDescription?: string
  rentAmount: number
  requiredFeeAmount: number
  splitPaymentUserList: SplitUserDataV2[]
  splitUserCount: number
  taxAmount: number
  totalAdults: number
  travelerBookingStatus: string
  travelerEmail: string
  travelerFullName: string
  travelerId: number
  travelerImage: string | null
  travelerMobileNumber: string
  travelerPaymentAmount: number
  whimstayTravelerServiceFeeAmount: number
  status: string | null
  channelUrl: string
  userIdentityVerifiedStatus: string
  riskRating: number
  surveySubmitted: boolean
  sameDayIdVerificationRequired?: boolean
}

export interface BookingListingParams {
  userId: number
}

export interface BookingDetailsFromBookingNoParams {
  bookingNo: string
}

export interface ContactUsFromDataType {
  conversationCheckInDate: string
  conversationCheckOutDate: string
  conversationNumberOfGuests: number
  conversationTravelDestination: string
  customerEmail: string
  customerName: string
  customerPhone: string
  messagePreview: string
  nickname: string
  pronouns: string
}

export interface PropertyData {
  addressFull: string
  city: string
  contactEmailId: string
  contactMobileNo: string
  country: string
  latitude: string
  longitude: string
  propertyId: string
  propertyName: string
  propertyRatingStarSum: number
  propertyTypeDesc: string
  state: string
}

export interface RboPropertyDataType {
  hostName: string
  hostProfileUrl: string
  rboHostUserId: number
  checkInInstruction: Record<string, string> | null
  checkOutInstruction: Record<string, string> | null
}

export interface PropertyDataFromBooking {
  address_full: string
  account_id: string | null
  city: string
  contactEmailId: string
  contactMobileNo: string
  country: string
  latitude: string
  longitude: string
  max_no_guests?: number
  max_pet_count?: number | null
  max_price?: number
  min_price?: number
  no_of_bedrooms?: number
  no_of_bathrooms?: number
  _id?: string
  pmc_id?: string
  property_id: string
  property_name: string
  property_rating_star_sum?: number
  property_rating_user_count?: number
  property_type_desc: string
  state: string
  suitable_pet?: boolean
  suitable_child?: boolean
  createdDt?: string | Date
  property_sub_type_desc?: string
  pms_system?: string
  minimum_age: number
  noOfBedrooms?: number
  reviews: ReviewsType[] | null
  cancellation_policy?: CancellationPolicy | null
  rboPropertyData?: RboPropertyDataType
  whimstayUserId: number
  checkInTime: string
  checkOutTime: string
  noOfbathrooms: number
  displayRecentlyAdded?: boolean
}

export interface SplitUserData {
  additionalFeeAmount: number
  isDeducted: number
  isOwner: number
  mobileNumber: string
  promoCodeAppliedAmount?: number
  promoCodeName?: string
  saveAmount: number
  status: string
  travelerPaymentAmount: number
  userId: number
  userName: string
}

export interface FeeList {
  applied: string
  currency: string
  description: string
  id: number
  value: number
}

export interface StagedPaymentList {
  travelerPaymentAmount: number
  paymentMethodId: string | null
  deducted: boolean
  paidDate?: string
  dueDate?: string
  paymentType: string
  paymentReceiptUrl: string
}

export interface SingleBookingDetail {
  adultNumber: number
  allowFullCancelRefund: boolean
  stripeSaveAmount?: number
  bookingCancelWithin24Hours: boolean
  bookedDate: string
  bookingAmount: number
  bookingId: number
  bookingNumber: string
  bookingStatus: string
  checkInDate: string
  checkOutDate: string
  childNumber: number
  requiredFeesAmount: number
  rentAmount: number
  depositAmount: number
  differentBillingAddress: boolean
  feeList: FeeList[]
  isConfirmedByPmc: boolean
  isSplited?: boolean
  maxNoGuest: number
  paymentMode?: string
  petNumber: number
  pmsType: string
  promoCodeAppliedAmount?: number
  promoCodeName?: string
  saveAmount: number
  taxAmount: number
  totalAdults: number
  totalRefundAmount: number
  travelerInsuranceAmount: number
  travelerPaymentAmount: number
  userId: number
  whimstayTravelerServiceFeeAmount: number
  paymentReceiptUrl: string
  isDifferentAddress: boolean
  travelerInsurance: string
  finalPaymentDueDate: string
  stagedPayment: boolean
  stagedPaymentTransactions: StagedPaymentList[]
  riskRating?: number
  userIdentityVerifiedStatus?: string
  userIdentityVerifyMessage?: string
  autoCancelHour?: number
  pdpFee?: number | null
  cancellation_policy?: CancellationPolicy | null
  cancellation_policy_text?: string
  change_booking_cancellation_text?: string
  cancellation_fee?: number | null
  refund_amount?: number | null
  cancellation_time_stamp?: string
  cancel_request_submitted_date?: string
  insuranceType: string | null
  isUserIdentityVerified?: boolean | null
  sameDayIdVerificationRequired?: boolean
}

export interface GuestInfoData {
  firstName: string
  lastName: string
  emailId: string
}

export interface TourTypesData {
  description: string
  type: string
  icon: string
}

export interface SupportSectionData {
  button: {
    action: string
    label: string
  }
  message: string
  title: string
}

export interface BookingDetailFromBookingNo {
  Fees: number
  ImagesURL: string
  PropertyData: PropertyData
  bookingData: SingleBookingDetail
  cancellationFees: number
  dailyAmount: number
  numberOfNight: number
  oldPropertyId?: string
  splitUserCount: number
  splitUserData: SplitUserData[]
}
export interface BookingDataFromBookingNo {
  Fees: number
  ImagesURL: string
  PropertyData: PropertyDataFromBooking
  bookingData: SingleBookingDetail
  cancellationFees: number
  dailyAmount: number
  numberOfNight: number
  oldPropertyId?: string
  splitUserCount: number
  splitUserData: SplitUserData[]
  guestInfo?: GuestInfoData[]
  adventures_section?: {
    tour_types: TourTypesData[]
  }
  support_section?: SupportSectionData
  userChannelUrl: string
  commission_amount?: number
}

export interface GetPropertiesTestRequestParams {
  Ids?: string[]
  adultCount?: number
  attachmentsCount?: number
  bounds: null | {
    // bounds payload updated in v3
    ne?: { lat: number; lng: number } | null
    nw?: { lat: number; lng: number } | null
    se?: { lat: number; lng: number } | null
    sw?: { lat: number; lng: number } | null
  }
  childrenCount?: number
  endDate?: string | null
  filters: FilterInterfaceForApiRequest
  isMapDragged: boolean
  isRequestForDiscoverByPlaceType?: boolean
  lat: number
  limit: number
  lng: number
  name: string | null
  noOfDays?: number
  page: number
  petAllowed?: boolean
  placeId: string | null
  placeType?: string | null
  startDate?: string | null
  whimstayPlus: boolean
  toggleOn: boolean
  sort: {
    highToLow: boolean
    lowToHigh: boolean
    bestDeals: boolean
    biggestSavings: boolean
    recommended: boolean
    guestRatings: boolean
  }
  propertyConfigTypeId?: number | null
}

export interface GetPropertiesGetRequestParams {
  adultCount?: number
  attachmentsCount?: number
  bounds: string
  childrenCount?: number
  endDate?: string | null
  FeaturesAndAmenities: string
  Location: string
  PropertyType?: string
  propertyTypeDesc?: string
  Safety?: string
  childAllowed: boolean
  eventAllowed: boolean
  partyAllowed: boolean
  isSearchingInMap: boolean
  withPolygon: boolean
  maxPrice: number
  minBathRoom: number
  minBedRoom: number
  minPrice: number
  numberOfGuest: number
  smokeAllowed: boolean
  mapDragged: boolean
  isRequestForDiscoverByPlaceType?: boolean
  lat: number
  limit: number
  lng: number
  name: string | null
  noOfDays?: number
  page: number
  petAllowed?: boolean
  placeId: string | null
  placeType?: string | null
  startDate?: string | null
  toggleOn: boolean
  sortBy: string
  propertyConfigTypeId?: number | null

  numberOfBathroom?: number
  numberOfBedroom?: number
  minBed?: number
  suitableChild?: boolean
  suitableInfant?: boolean

  cancellable?: boolean
  nearByProperties?: boolean
  multiUnitCollapsedEnabled?: boolean
  expandedMiles?: number | null
  ratingEqualAndAbove?: number | null
}

export interface PropertyImageData {
  file_description: string | null
  file_name: string
  file_url: string
  height: number
  image_full_url: string
  image_order: number
  is_cover_img: boolean
  is_hide: boolean
  is_video: boolean
  photo_id: string | null
  pmc_id: string
  unit_d: string
  upload_status: string
  width: number
  // pms_photo_id?: string | null
}

// NOT USED in web
export interface PropertyRegionalImageData {
  file_description: string | null
  file_url: string | null
  pmc_id: string | null
  unit_d: string | null
  image_order: number
  photo_id: string | null
  file_name: string
  is_cover_img: boolean
  upload_status: string | null
  width: number | null
  height: number | null
  image_full_url: string
  is_hide: boolean
  is_video: boolean
}

// PropertyData response updated in v3
// Do not rename it yet, as old is called "PropertyData" and new is called "PropertyDataV2"
export interface PropertyDataV2 {
  _id: string
  active: boolean
  averagePrice: number
  checkInDate: string
  checkOutDate: string
  city: string
  cleaningAndOwnerFees: number
  createdDt?: number
  country: string
  discount: number
  isPriceDrop?: boolean
  images: PropertyImageData[]
  kitchen: boolean
  latitude: number
  longitude: number
  lowestPrice?: number
  maxPrice: number

  minPrice: number
  noOfBathroom: number
  noOfBedroom: number
  noOfBeds: number
  noOfGuest: number
  noOfNights: number
  oldPropertyId: string | number
  originalTotalBeforeTaxes: number
  petsAllowd: boolean
  pmc_id: string
  pms_unit_id: string
  propertyName: string
  muUnitNumber?: number
  multiUnitCount: number | null
  multiUnitGrp: string | null
  multiUnitSubGrp?: string | null
  propertyRatingUserCount: number
  propertyStarSum: number
  propertyTypeDesc: string
  propertySubTypeDesc: string
  serviceFee: number
  state: string
  totalBeforeTaxes: number
  taxes: number
  wifi: boolean
  totalSavedPercent: number
  perNightSavedPercent: number
  postCode?: string | number | null
  postalName?: string | null

  impressionTrackerUrl?: string | null
  landingPageClickTrackerUrl?: string | null
  otaName: string | null
  whimstaySaveAmount: number | null
  count: number | null
  displayRecentlyAdded?: boolean
  preferredHostBadge?: boolean
  sharedBathroom?: boolean
}

export interface RoomDetails {
  Description: string
  ImageURL: string
  Name: string
}

export interface HealthSafetyType {
  carbonmonoxidealarm: string | null
  lead: string | null
  smokealarm: string | null
  StagedPaymentConfig: string | null
  isStagedPaymentDisabled: string | null
}

export interface CancellationPolicy {
  gracePeriod: number | null
  gracePeriodPercentage: number | null
  policy?: PolicyDetail[] | null
}

export interface PolicyDetail {
  id: string
  category: string
  percentage: number
  validFrom: number
  validTo: number
  description: string
  updatedDt: number
}

export interface PropertyTypeV2 {
  NumericPropertyId: string
  _id: string
  addHouse_rule?: string | null
  account_id: string | null
  address_full: string
  addressline1: string
  addressline2: string
  checkInInstruction: string | null
  checkOutInstruction: string | null
  check_in_time: string
  check_out_time: string
  city: string
  cleaning_fee: number | null
  contactEmailId: string
  contactMobileNo: string
  contactTemplateId: number
  country: string
  currency: string
  discPer?: number | null
  discountTemplateId: number
  latitude: string
  longitude: string
  max_no_guests: number
  max_pet_count?: number | null
  max_price: number
  min_price: number
  nightlyTaxPer: number
  no_of_bathrooms: number
  no_of_bedrooms: number
  no_of_beds: number
  no_of_units: number
  otherDetails?: string | null
  otherFee?: number | null
  party_allowed: boolean
  pgHostAccId: number
  pmc_id: string
  pms_system: string
  postal_code: string
  property_desc: string
  property_id: string
  property_name: string
  property_rating_star_sum?: number | null
  property_rating_user_count?: number | null
  property_sub_type_desc: string
  property_type_desc: string
  pulledProperty: boolean
  reviews: ReviewsType[] | null
  room_details: RoomDetails[]
  serviceTaxPer: number
  smoke_allowed: boolean
  squareFt?: number | null
  state: string
  suitable_child: boolean
  suitable_infant: boolean
  suitable_pet: boolean
  superhogListingId: number | null
  unit_id: string
  unit_number?: number | null
  wheelchair_accessable: boolean
  createdDt?: number | Date
  delete: boolean
  postal_name?: string | null
  minimum_age: number
  dynamicFields: HealthSafetyType | null
  cancellation_policy: CancellationPolicy
  status?: string | null
  displayRecentlyAdded?: boolean | null
  cancelPolicyDatelessText?: string | null
  cancelPolicyFutureRefundText?: string | null
  cancelPolicyPastRefundText?: string | null
  featuredUnit?: boolean | null
  preferredHostBadge?: boolean
  sharedBathroom?: boolean
  seasonalDateLessText?: string | null
}

//checked
export interface PropertyAttachmentType {
  file_description: string
  file_name: string
  file_url: string
  height: number
  image_full_url: string
  image_order: number
  is_cover_img: false
  is_hide: boolean
  is_video: boolean
  photo_id: string | number | null
  pmc_id: string
  unit_d: string
  upload_status: string
  width: number
}

export interface FeaturesByCategoryType {
  category_name: string
  keywords: {
    category_name: string
    condition: string | number | null
    id: number
    is_popular: boolean
    key_icon: string
    key_index: string | number | null
    key_name: string
    feature_source?: string | null
    key_description?: string | null
    pdp_priority?: number | null
  }[]
}

export interface StructuredDescriptionType {
  introduction?: string | null
  property_details?: string | null
  location_highlights?: string | null
  house_rules?: string | null
  additional_info?: string | null
  combined_description?: string | null
}

export interface Rule {
  name: string
  order: number
  image_url: string
  front_page: boolean
  description: string | null
}

export interface HouseRulesAndSafety {
  [key: string]: Rule[]
}

export interface RboPropData {
  addHouse_rule: HouseRulesAndSafety
  safety_and_property: HouseRulesAndSafety
  rbo_host_user_id?: string
}

export interface PropertyHighlightType {
  text: string
  tag: string
  icon: string
}

export interface DetailedPropertyDataType {
  active: boolean
  averagePrice: number
  avgBasePrice: number | null
  calendar: CalendarObject[]
  calendarRate: CalendarObject
  checkArrivalDeparture: boolean
  createdDt: number | Date
  effMinPrice: number | null
  featureKeyId?: string
  hostName: string
  id: string
  isHide: false
  location: any
  manualUpdated?: string
  new: boolean
  pmcId: string
  pmsSystem: string
  multiUnitGrp?: string | null
  featuredUnit?: boolean | null
  preferredHostBadge?: boolean
  precisionPricingStatus?: PrecisionPricingStatusType | null
  propData: PropertyTypeV2
  rboPropData: RboPropData
  propDesc?: StructuredDescriptionType | null
  propFeatures: FeaturesByCategoryType[]
  propImages: PropertyAttachmentType[]
  propertyId: string
  reviewComments?: null | string
  status: string
  unitId: string
  updatedDt: number | Date
  delete: boolean
  hostProfileUrl?: string | null
  hostProfileName?: string | null
  hostRating?: number | null
  hostReviews?: number | null
  yearsOfHosting?: number | null
  yearsMonth?: number | null
  whimstayUserId?: number | null
  propertyReviewSummary?: Partial<Record<number, number>> | null
  securityDepositText?: string | undefined
  aiReviewSummary?: string
  propertyHighlights?: PropertyHighlightType[]
  displayRecentlyAdded?: boolean | null
  cancelPolicyDatelessText?: string | null
  cancelPolicyFutureRefundText?: string | null
  cancelPolicyPastRefundText?: string | null
  sharedBathroom?: boolean
  seasonalDateLessText?: string
}
export interface CalendarObject {
  arrival: boolean
  available: boolean
  base_price: number
  departure: boolean
  max_nights: number
  min_nights: number
  valid_from: string
}

export interface MultiUnitsType {
  _id: string
  active: boolean
  averagePrice: number
  address_full: string
  checkInDate: string
  checkOutDate: string
  city: string
  cleaningAndOwnerFees: number
  createdDt?: number
  country: string
  discount: number
  images: PropertyImageData[]
  kitchen: boolean
  latitude: number
  longitude: number
  maxPrice: number
  minPrice: number
  minimumAgeLimit?: number
  noOfBathroom: number
  noOfBedroom: number
  noOfBeds: number
  noOfGuest: number
  noOfNights: number
  oldPropertyId: string | number
  originalTotalBeforeTaxes: number
  petsAllowd: boolean
  suitable_child: boolean
  pmc_id: string
  pms_unit_id: string
  pms_system: string
  propertyName: string
  propertyRatingUserCount: number
  propertyStarSum: number
  propertyTypeDesc: string
  propertySubTypeDesc: string
  serviceFee: number
  state: string
  totalBeforeTaxes: number
  wifi: boolean
  totalSavedPercent: number
  perNightSavedPercent: number
  postCode?: string | number | null
  postalName?: string | null
  impressionTrackerUrl?: string | null
  landingPageClickTrackerUrl?: string | null
  multiUnitGrp: string | null
  multiUnitCount: number | null
}

export interface MultiUnitSummaryType {
  maxBaths: number
  maxBeds: number
  maxGuests: number
  studioAvailable: boolean
  bedroomFilters: number[]
}

export interface MultiUnitPropertyDetailType {
  multiUnits: MultiUnitsType[] | null
  multiUnitSummary: MultiUnitSummaryType | null
}

export interface RecentlySearches {
  name: string
  placeId: string
  checkInDate: string
  checkOutDate: string
  adultCount: number
  childCount: number
  petAllowed: boolean
  createdDate: string
  lat: number
  lng: number
}
